import { HttpClient } from "@angular/common/http";
import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { MatColors } from "@fuse/mat-colors";
import { CalendarEvent } from "angular-calendar";
import { UiService } from "app/helper-components/UiService";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";

@Component({
  selector: "app-uripinar",
  templateUrl: "./uripinar.component.html",
  styleUrls: ["./uripinar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class UripinarComponent {
  title = "";
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  second = true;
  uripinar: any;
  action: string;
  event: CalendarEvent;
  eventForm: FormGroup;
  dialogTitle: string;
  presetColors = MatColors.presets;
  myInput: any;
  list = false;
  showMore = false;
  uripinarList: any = [];
  page: any = 0;
  const_id: any = 0;
  isWait: boolean = false;

  constructor(
    public matDialogRef: MatDialogRef<UripinarComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _formBuilder: FormBuilder,
    private uiService: UiService,
    private postService: PostService,
    private httpClient: HttpClient,
    public dialogRef: MatDialogRef<FuseConfirmDialogComponent>
  ) {
    this.const_id = this._data.parameters.const_id;
  }

  ngOnInit() {}

  OnInput(value, seeMore = false) {
    if (!seeMore) {
      this.uripinarList = [];
    }

    if (this.const_id !== undefined) {
      if (value.length > 2) {
        this.isWait = true;
        const formData = new FormData();
        if (
          this._data.parameters.hasOwnProperty("event_level") &&
          this._data.parameters.event_level == "country"
        ) {
          formData.append("searchMember", "1");
          formData.append("input", value);
          formData.append("page", this.page);
        } else {
          formData.append("searchMemberInConstituency", "1");
          formData.append("input", value);
          formData.append("page", this.page);
          formData.append("const_id", this.const_id);
        }

        this.postService
          .post(environment.API_MEMBER, formData)
          .subscribe((val) => {
            this.isWait = false;
            this.list = true;
            this.showMore = val.data.length / val.limit > 1;
            if (val.limit * val.page > val.total_count) {
              this.showMore = false;
            }
            this.uripinarList = [...this.uripinarList, ...val.data];
          });
      } else {
        this.list = false;
      }
    } else {
      this.httpClient
        .get(environment.MEMBER_bY_MEMBER_ID, {
          params: {
            member_id: value,
          },
          headers: this.postService.getHeaders(),
        })
        .subscribe((val: any) => {
          // console.log(val);

          if (val.status == "success") {
          } else {
          }
        });
    }
  }

  showEmptyProfile(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }

  getUripinar(uripinar: any) {
    var selectedUripinar = uripinar;
    this.dialogRef.close({ data: selectedUripinar });
  }

  seeMore(value) {
    this.page += 1;
    this.OnInput(value, true);
  }

  searchClick(value) {
    this.isWait = true;
    this.list = false;
    this.showMore = false;
    this.uripinarList = [];
    const formData = new FormData();
    formData.append("searchMember", "1");
    formData.append("member_id", value);

    this.postService.post(environment.API_MEMBER, formData).subscribe((val) => {
      this.isWait = false;
      this.list = true;
      this.showMore = false;
      if (val.status == "success") {
        this.uripinarList = [val.data];
      }
    });
  }

  ngAfterViewInit() {}
}
